export default "__VITE_ASSET__XZOYunS3__"